import * as actionTypes from "../../actions/actionTypes";

const initState = {
  products: [],
  productsLoading: false,
  productsError: null,
  sku: [],
  skuLoading: false,
  skuError: null,
};

const productsReducer = (state = initState, action) => {
  switch (action.type) {
    // PRODUCTS
    case actionTypes.FETCH_PRODUCTS_START:
      return {
        ...state,
        productsLoading: true,
      };
    case actionTypes.FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.products,
        productsLoading: false,
      };
    case actionTypes.FETCH_PRODUCTS_FAILED:
      return {
        ...state,
        productsError: action.err,
        productsLoading: false,
      };
    // SKU
    case actionTypes.FETCH_SKU_START:
      return {
        ...state,
        skuLoading: true,
        fetchTransactionsLoading: true,
      };
    case actionTypes.FETCH_SKU_SUCCESS:
      return {
        ...state,
        skuLoading: false,
        sku: action.sku,
      };
    case actionTypes.FETCH_SKU_FAILED:
      return {
        ...state,
        skuLoading: false,
        skuError: action.err,
      };

    default:
      return state;
  }
};

export default productsReducer;
